export default __webpack_public_path__ + "static/media/abstract-painting.a507a8db.png";